import { TemplateConfig } from '@/types';

const collectionThemePresets: TemplateConfig['themes'] = [
  {
    id: 'blue',
    name: '商务蓝',
    colors: { primary: '#2563EB', secondary: '#3B82F6', accent: '#DBEAFE', background: '#FFFFFF', surface: '#EFF6FF', text: '#111827', textMuted: '#6B7280', border: '#BFDBFE' },
    font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'green',
    name: '清新绿',
    colors: { primary: '#059669', secondary: '#10B981', accent: '#D1FAE5', background: '#FFFFFF', surface: '#ECFDF5', text: '#064E3B', textMuted: '#6B7280', border: '#A7F3D0' },
    font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'red',
    name: '砖红',
    colors: { primary: '#DC2626', secondary: '#EF4444', accent: '#FEE2E2', background: '#FFFFFF', surface: '#FEF2F2', text: '#7F1D1D', textMuted: '#6B7280', border: '#FECACA' },
    font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'purple',
    name: '优雅紫',
    colors: { primary: '#7C3AED', secondary: '#8B5CF6', accent: '#EDE9FE', background: '#FFFFFF', surface: '#F5F3FF', text: '#3B0764', textMuted: '#6B7280', border: '#C4B5FD' },
    font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'dark',
    name: '高级黑',
    colors: { primary: '#111827', secondary: '#374151', accent: '#E5E7EB', background: '#FFFFFF', surface: '#F9FAFB', text: '#111827', textMuted: '#6B7280', border: '#D1D5DB' },
    font: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
];

// Selected 29 real templates from ResumeCollection github repo
// Each has a dedicated React component with SVG background decorations

export const collectionTemplateConfigs: TemplateConfig[] = [
  {
    id: 'cn-002',
    name: '简约风求职',
    slug: 'cn-002',
    description: '来源于简历收集库，简约风求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'minimal',
    tags: ['简约', '通用', '蓝色'],
    thumbnail: '/templates/collection/cn-002.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-004',
    name: '砖红色通用',
    slug: 'cn-004',
    description: '来源于简历收集库，砖红色通用风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'business',
    tags: ['商务', '行政', '红色'],
    thumbnail: '/templates/collection/cn-004.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#DC2626',
          secondary: '#DC2626',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-005',
    name: '左右双栏风',
    slug: 'cn-005',
    description: '来源于简历收集库，左右双栏风风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'modern',
    tags: ['双栏', '技术', '蓝色'],
    thumbnail: '/templates/collection/cn-005.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-007',
    name: '项目经理负责人',
    slug: 'cn-007',
    description: '来源于简历收集库，项目经理负责人风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'business',
    tags: ['管理', '商务', '深色'],
    thumbnail: '/templates/collection/cn-007.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-008',
    name: '护士免费求职',
    slug: 'cn-008',
    description: '来源于简历收集库，护士免费求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'medical',
    tags: ['医护', '清新', '蓝色'],
    thumbnail: '/templates/collection/cn-008.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-009',
    name: '创意免费求职',
    slug: 'cn-009',
    description: '来源于简历收集库，创意免费求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'creative',
    tags: ['创意', '设计', '浅蓝'],
    thumbnail: '/templates/collection/cn-009.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-010',
    name: '国际贸易风',
    slug: 'cn-010',
    description: '来源于简历收集库，国际贸易风风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'trade',
    tags: ['外贸', '商务', '蓝色'],
    thumbnail: '/templates/collection/cn-010.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-012',
    name: '简约风免费求职',
    slug: 'cn-012',
    description: '来源于简历收集库，简约风免费求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'minimal',
    tags: ['时间线', '时间轴', '简约', '应届', '红色'],
    thumbnail: '/templates/collection/cn-012.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-014',
    name: '互联网行业',
    slug: 'cn-014',
    description: '来源于简历收集库，互联网行业风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'internet',
    tags: ['技术', '互联网', '多彩'],
    thumbnail: '/templates/collection/cn-014.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-016',
    name: '财务',
    slug: 'cn-016',
    description: '来源于简历收集库，财务风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'finance',
    tags: ['财务', '商务', '蓝色'],
    thumbnail: '/templates/collection/cn-016.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-017',
    name: '浅绿色免费的',
    slug: 'cn-017',
    description: '来源于简历收集库，浅绿色免费的风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'fresh',
    tags: ['清新', '通用', '绿色'],
    thumbnail: '/templates/collection/cn-017.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#059669',
          secondary: '#059669',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-021',
    name: '市场营销求职',
    slug: 'cn-021',
    description: '来源于简历收集库，市场营销求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'marketing',
    tags: ['市场', '营销', '蓝色'],
    thumbnail: '/templates/collection/cn-021.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-023',
    name: '专为工程师设计的技术',
    slug: 'cn-023',
    description: '来源于简历收集库，专为工程师设计的技术风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'engineering',
    tags: ['工程师', '技术', '创意'],
    thumbnail: '/templates/collection/cn-023.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-026',
    name: '左右分栏黑色风',
    slug: 'cn-026',
    description: '来源于简历收集库，左右分栏黑色风风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'modern',
    tags: ['双栏', '深色', '橙色'],
    thumbnail: '/templates/collection/cn-026.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#1F2937',
          secondary: '#1F2937',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-027',
    name: '简约风绿色风格求职',
    slug: 'cn-027',
    description: '来源于简历收集库，简约风绿色风格求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'fresh',
    tags: ['简约', '绿色', '通用'],
    thumbnail: '/templates/collection/cn-027.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#059669',
          secondary: '#059669',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-037',
    name: '临床护士专业简历',
    slug: 'cn-037',
    description: '来源于简历收集库，临床护士专业简历风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'medical',
    tags: ['医护', '专业', '蓝色'],
    thumbnail: '/templates/collection/cn-037.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-044',
    name: '客户经理',
    slug: 'cn-044',
    description: '来源于简历收集库，客户经理风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'sales',
    tags: ['时间线', '时间轴', '客户经理', '管理', '商务'],
    thumbnail: '/templates/collection/cn-044.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-053',
    name: '视觉设计师',
    slug: 'cn-053',
    description: '来源于简历收集库，视觉设计师风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'creative',
    tags: ['视觉设计', '设计', '粉色'],
    thumbnail: '/templates/collection/cn-053.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-061',
    name: '左右风格求职',
    slug: 'cn-061',
    description: '来源于简历收集库，左右风格求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'modern',
    tags: ['双栏', '商务', '深色'],
    thumbnail: '/templates/collection/cn-061.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-063',
    name: '创意设计师简历模板',
    slug: 'cn-063',
    description: '来源于简历收集库，创意设计师简历模板风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'creative',
    tags: ['设计', '正式', '黑白'],
    thumbnail: '/templates/collection/cn-063.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-065',
    name: '美术主编免费求职',
    slug: 'cn-065',
    description: '来源于简历收集库，美术主编免费求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'creative',
    tags: ['艺术', '编辑', '绿色'],
    thumbnail: '/templates/collection/cn-065.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-069',
    name: '酒红色应届生',
    slug: 'cn-069',
    description: '来源于简历收集库，酒红色应届生风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'campus',
    tags: ['应届', '校招', '酒红'],
    thumbnail: '/templates/collection/cn-069.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#DC2626',
          secondary: '#DC2626',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-071',
    name: '开发工程师',
    slug: 'cn-071',
    description: '来源于简历收集库，开发工程师风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'internet',
    tags: ['开发', '技术', '工程师'],
    thumbnail: '/templates/collection/cn-071.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-109',
    name: '简约简历模板word',
    slug: 'cn-109',
    description: '来源于简历收集库，简约简历模板word风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'minimal',
    tags: ['简约', '蓝色', '通用'],
    thumbnail: '/templates/collection/cn-109.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-113',
    name: '个人简约免费求职',
    slug: 'cn-113',
    description: '来源于简历收集库，个人简约免费求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'minimal',
    tags: ['简约', '通用', '米色'],
    thumbnail: '/templates/collection/cn-113.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-116',
    name: '绿色风格求职',
    slug: 'cn-116',
    description: '来源于简历收集库，绿色风格求职风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'fresh',
    tags: ['时间线', '时间轴', '绿色', '清新', '通用'],
    thumbnail: '/templates/collection/cn-116.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#059669',
          secondary: '#059669',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-118',
    name: '左右分栏',
    slug: 'cn-118',
    description: '来源于简历收集库，左右分栏风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'modern',
    tags: ['双栏', '灰色', '通用'],
    thumbnail: '/templates/collection/cn-118.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-129',
    name: '左右分栏免费创意',
    slug: 'cn-129',
    description: '来源于简历收集库，左右分栏免费创意风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'creative',
    tags: ['双栏', '创意', '深色'],
    thumbnail: '/templates/collection/cn-129.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
  {
    id: 'cn-161',
    name: '简约风',
    slug: 'cn-161',
    description: '来源于简历收集库，简约风风格',
    layout: 'single-column',
    supportsPhoto: true,
    supportsMultiPage: true,
    defaultSections: ["personal", "intention", "summary", "education", "workExperience", "projects", "skills", "certificates", "languages"],
    isPremium: true,
    category: 'minimal',
    tags: ['简约', '青绿', '通用'],
    thumbnail: '/templates/collection/cn-161.jpg',
    themes: [
      {
        id: 'default',
        name: '默认',
        colors: {
          primary: '#2563EB',
          secondary: '#2563EB',
          accent: '#F3F4F6',
          background: '#FFFFFF',
          surface: '#F9FAFB',
          text: '#111827',
          textMuted: '#6B7280',
          border: '#E5E7EB',
        },
        font: {
          heading: 'Noto Sans SC',
          body: 'Noto Sans SC',
        },
      },
    ],
    fonts: { heading: 'Noto Sans SC', body: 'Noto Sans SC' },
  },
].map((template) => ({
  ...template,
  themes: collectionThemePresets,
}));

export const collectionComponentMap: Record<string, string> = {
  'cn-002': 'cn-002',
  'cn-004': 'cn-004',
  'cn-005': 'cn-005',
  'cn-007': 'cn-007',
  'cn-008': 'cn-008',
  'cn-009': 'cn-009',
  'cn-010': 'cn-010',
  'cn-012': 'cn-012',
  'cn-014': 'cn-014',
  'cn-016': 'cn-016',
  'cn-017': 'cn-017',
  'cn-021': 'cn-021',
  'cn-023': 'cn-023',
  'cn-026': 'cn-026',
  'cn-027': 'cn-027',
  'cn-037': 'cn-037',
  'cn-044': 'cn-044',
  'cn-053': 'cn-053',
  'cn-061': 'cn-061',
  'cn-063': 'cn-063',
  'cn-065': 'cn-065',
  'cn-069': 'cn-069',
  'cn-071': 'cn-071',
  'cn-109': 'cn-109',
  'cn-113': 'cn-113',
  'cn-116': 'cn-116',
  'cn-118': 'cn-118',
  'cn-129': 'cn-129',
  'cn-161': 'cn-161',
};
